import adv1 from '../assets/images/advantage-1.svg';
import adv2 from '../assets/images/advantage-2.svg';
import adv3 from '../assets/images/advantage-3.svg';
import adv4 from '../assets/images/advantage-4.svg';
import adv5 from '../assets/images/advantage-5.svg';
import adv6 from '../assets/images/advantage-6.svg';

export const APP_ADVANTAGES = [
  {
    id: 'advantage1',
    content: 'advantage1',
    image: adv1,
  },
  {
    id: 'advantage2',
    content: 'advantage2',
    image: adv2,
  },
  {
    id: 'advantage3',
    content: 'advantage3',
    image: adv3,
  },
  {
    id: 'advantage4',
    content: 'advantage4',
    image: adv4,
  },
  {
    id: 'advantage5',
    content: 'advantage5',
    image: adv5,
  },
  {
    id: 'advantage6',
    content: 'advantage6',
    image: adv6,
  },
];
